<template>
    <div>
      <video
        ref="videoPlayer"
        controls
        width="100%"
        height="auto"
        :poster="poster"
        style="border-radius: 10px"
      ></video>
    </div>
  </template>
  
  <script>
  import Hls from 'hls.js';
  
  export default {
    props: ['src', 'poster'], // added poster here
    mounted() {
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(this.src);
        hls.attachMedia(this.$refs.videoPlayer);
      } else if (this.$refs.videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
        this.$refs.videoPlayer.src = this.src;
      }
    },
  };
  </script>
  

<!-- <template>
    <div>
      <video
        ref="videoPlayer"
        controls
        width="100%"
        height="auto"
        style="border-radius: 10px"
      ></video>
    </div>
  </template>
  
  <script>
  import Hls from 'hls.js';
  
  export default {
    props: ['src'], // pass your S3 m3u8 link here
    mounted() {
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(this.src);
        hls.attachMedia(this.$refs.videoPlayer);
      } else if (this.$refs.videoPlayer.canPlayType('application/vnd.apple.mpegurl')) {
        this.$refs.videoPlayer.src = this.src;
      }
    },
  };
  </script>
   -->